
import React, { Suspense, lazy, useRef, useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/web/images/logo.png";
import herobg from "../assets/web/images/hero-bg-2.png";
import appStore from "../assets/web/images/app-store-1.png";
import playStore from "../assets/web/images/play-store-2.png";
import s1 from "../assets/web/images/padlock.png";
import s2 from "../assets/web/images/File.png";
import s3 from "../assets/web/images/plane.png";
import s4 from "../assets/web/images/pc.png";
import s5 from "../assets/web/images/setting.png";
import s6 from "../assets/web/images/download.png";
import download from "../assets/web/images/download-mini-bg.png";
import everyone from "../assets/web/images/everyone-pic.png";

const Webassetscss = React.lazy(() => import('../Webassets'));
const  Homeinfo = (props) => {
  return (
    <>
    <Suspense>
    <Webassetscss />
 
    <section className=" ivo-hero-section">
        <div className="container ivo-section ivo-ovrflow-hidden">
            <div className="row ivo-ovrflow-hidden">
                <div className="col-lg-6 col-12 animate__animated  wow  animate__fadeInLeft">
                    <div className="ivo-text-box">
                        <h1 className="ivo-hero-heading">
                        IVOIRE Global Trading: Connecting Commodities and Stocks to the World.

                        </h1>
                        <p style={{color: "#fff"}}  className="ivo-para">With advanced tools and real-time data, Experience a user-friendly interface, robust analytics, and seamless execution, all tailored to enhance your profitability in the dynamic world of commodity and stock trading. </p>
                        <div className="ivo-hero-link-box">
                            <button className="btn ivo-site-btn ivo-site-btn-v-3 px-5" >
                               <Link to="signup">Get Started </Link></button>
                            <Link className="mr-2" href=""><img src={appStore} alt="" /></Link> <Link href=""><img src={playStore} alt="" /></Link>
                        </div>
                    </div>

                </div>
                <div className="col-lg-6 col-12 d-flex align-items-center animate__animated  wow  animate__fadeInRight">
                    <div className="ivo-img-box">
                        <img className="img-fluid" src={herobg} alt="hero-bg-2" />

                    </div>

                </div>
            </div>
        </div>
    </section>
    <section className="ivo-section ivo-detail-section pb-0">
        <div className="container ">
            <div className="row ivo-ovrflow-hidden">
            <div className="col-lg-6 col-12 col-sm-12 mb-5 animate__animated  wow animate__fadeInUp animate__delay-1s">
                    <div className="ivo-shadow-box detail-box">
                        <div className="ivo-img-box">
                            <img src={s2} alt="lock" />
                        </div>
                        <h4 className="detail-box-heading">
                        FAST KYC VERIFICATION FOR HASSLE-FREE ON BOARDING
                        </h4>
                        <p className="ivo-para">Enjoy a seamless on boarding experience with our fast KYC verification, allowing you to focus on what matters most – trading and maximizing your investment opportunities.</p>
                    </div>

                </div>
                
                <div className="col-lg-6 col-12 col-sm-12 mb-5 animate__animated  wow animate__fadeInUp animate__delay-1s">
                    <div className="ivo-shadow-box detail-box">
                        <div className="ivo-img-box">
                            <img src={s1} alt="lock" />
                        </div>
                        <h4 className="detail-box-heading">LIVE MARKET DATA</h4>
                        <p className="ivo-para">Get real-time updates on commodity and stock prices, indices, and market trends directly on the homepage.</p>
                    </div>

                </div>

                
                <div className="col-lg-6 col-12 col-sm-12 mb-5 animate__animated  wow animate__fadeInUp animate__delay-1s">
                    <div className="ivo-shadow-box detail-box">
                        <div className="ivo-img-box">
                            <img src={s3} alt="lock" />
                        </div>
                        <h4 className="detail-box-heading">
                                QUICK VIEW COMMODITY AND STOCKS
                        </h4>
                        <p className="ivo-para">: Stay up-to-date with the latest market trends and movements with our quick view feature. Our platform allows you to access essential information on your favourite commodities and stocks at a glance, without having to navigate through multiple screens. </p>


                    </div>

                </div>
                <div className="col-lg-6 col-12 col-sm-12 mb-5 animate__animated  wow animate__fadeInUp animate__delay-1s">
                    <div className="ivo-shadow-box detail-box">
                        <div className="ivo-img-box">
                            <img src={s4} alt="lock" />
                        </div>
                        <h4 className="detail-box-heading">
                        CROSS-PLATFORM AVAILABILITY
                        </h4>
                        <p className="ivo-para">IVOIRE is accessible across multiple devices and operating systems, you can enjoy a consistent and seamless trading experience across all platforms. </p>
                    </div>

                </div>
                <div className="col-lg-6 col-12 col-sm-12 mb-5 animate__animated  wow animate__fadeInUp animate__delay-1s">
                    <div className="ivo-shadow-box detail-box">
                        <div className="ivo-img-box">
                            <img src={s5} alt="lock" />
                        </div>
                        <h4 className="detail-box-heading">
                                SAFE AND SECURE TRADING
                        </h4>
                        <p className="ivo-para">: Your security is our top priority. We employ robust measures to ensure your trading experience is safe and secure. Our platform utilizes industry-leading encryption protocols to protect your personal information and financial transactions.</p>


                    </div>

                </div>
                <div className="col-lg-6 col-12 col-sm-12 mb-5 animate__animated  wow animate__fadeInUp animate__delay-1s">
                    <div className="ivo-shadow-box detail-box">
                        <div className="ivo-img-box">
                            <img src={s6}  alt="lock" />
                        </div>
                        <h4 className="detail-box-heading">
                         CUSTOMER SUPPORT
                        </h4>
                        <p className="ivo-para">We are dedicated to providing exceptional customer support to ensure your trading experience is smooth and hassle-free. Our knowledgeable support team is available to assist you with any inquiries, technical issues, or account-related concerns you may have.</p>


                    </div>

                </div>

            </div>
        </div>
    </section>
    <section className="ivo-section ivo-download-box">
        <div className="container ivo-ovrflow-hidden">
            <div className="ivo-download-box-content ivo-ovrflow-hidden">
                <div className="ivo-download-text text-center animate__animated  wow animate__fadeInUp animate__delay-1s">
                    <h1 style={{color: "#ffff"}}>
                        DOWNLOAD IVOIRE
                    </h1>
                    <div className="mt-2">
                        <a className="mr-2" href=""><img src={appStore}   /></a> <a href="">
                          <img src={playStore} /></a>
                    </div>
                </div>
                <div className="ivo-img-box animate__animated  wow animate__fadeInUp animate__delay-1s">
                    <img className="img-fluid" src={download} />
                </div>


            </div>
        </div>
    </section>
    <section className="ivo-section ivo-for-everyone">
        <div className="container">
            <div className="row ivo-ovrflow-hidden">
                <div className="col-lg-6 col-sm-12 col-12 animate__animated  wow  animate__fadeInLeft animate__delay-1s">
                    <div className="ivo-text-box">
                        <h2 className="ivo-heading">
                            <span  style={{color: "#2D475B"}}>DELIVERING</span> 
                             A WORLD-CLASS TRADING EXPERIENCE
                        </h2>
                        <p className="ivo-para everyone-sub-h">
                        Delivering a world-class trading experience is all about providing traders with the tools, resources, and support they need to succeed. At the heart of this experience is a trading platform that is intuitive, fast, and reliable, allowing traders to easily execute trades and manage their portfolios.

                        </p>
                        <p className="ivo-para everyone-sub-h">
                        In addition, a world-class trading experience includes access to a wide range of markets and instruments, including commodities and stocks. This allows traders to diversify their portfolios and take advantage of market opportunities as they arise.

                        </p>
                        <p className="ivo-para">
                        To further enhance the trading experience, robust market data and analysis tools are essential. Traders need real-time data and insights to make informed decisions and stay ahead of the curve. And when questions or issues arise, responsive customer support is critical to quickly resolve any concerns and keep traders focused on their goals.

                        </p>

                    </div>

                </div>
                <div className="col-lg-6 col-sm-12 col-12 animate__animated  wow  animate__fadeInRight animate__delay-1s">
                    <div className="ivo-img">
                        <img className="img-fluid" src={everyone} alt="everyone-pic" />
                    </div>
                </div>
            </div>
        </div>

    </section>
   
    </Suspense>
    </>

  );
}

export default Homeinfo;
